import { render, staticRenderFns } from "./pageDetail.vue?vue&type=template&id=5cc09c0e&scoped=true"
import script from "./pageDetail.vue?vue&type=script&lang=js"
export * from "./pageDetail.vue?vue&type=script&lang=js"
import style0 from "./pageDetail.vue?vue&type=style&index=0&id=5cc09c0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc09c0e",
  null
  
)

export default component.exports